
import { SharedProps } from "./types"

export const fieldsToInclude = [
    "author",
    "language",
    "urihash",
    "objecttype",
    "collection",
    "source",
    "permanentid",
    "date",
    "parents",
    "commontab",
    "filetype",
    "nes_prd_sku",
    "nes_prd_image_url",
    "nes_prd_categories",
    "nes_prd_sleeve_main_price",
    "nes_prd_name",
    "nes_prd_price",
    "nes_prd_technology",
    "faq_question",
    "faq_answer",
    "nes_prd_cup_size_oz",
    "nes_prd_sales_multiple",
    "nes_prd_cup_size",
    "nes_prd_unit_quantity",
    "nes_article_category",
    "nes_prd_color",
    "nes_prd_color_css",
    "nes_prd_usage",
    "nes_prd_intensity",
    "nes_prd_quantities",
    "nes_prd_bundled",
    "nes_prd_strikethrough_price",
]

export const fieldsToIncludeB2B = [...fieldsToInclude,
    "nes_prd_price_display",
    "nes_prd_sku"
]

export const getCoveoAnalytics = ({ visitorId }: { visitorId: string }) => {
    return ({
        clientId: visitorId,
        "clientTimestamp": new Date().toISOString(),
        "documentReferrer": "default",
        "originContext": "Search",
        "documentLocation": window.location.href
    })
}

export const getCoveoContext = (ctx: Pick<SharedProps, "website" | "sitename" | "contextWebsite" | "contextSitename" | "lang" | "locale" | "country">) => {
    return ({
        "website": ctx.website,
        "sitename": ctx.sitename,
        "context_website": ctx.contextWebsite,
        "context_sitename": ctx.contextSitename,
        "language": ctx.lang,
        "locale": ctx.locale,
        "country": ctx.country
    })
}

export const getCoveoGroupBy = (q: string) => {
    return [
        {
            "field": "@commontab",
            "queryOverride": q,
            "constantQueryOverride": "@uri",
            "advancedQueryOverride": "@uri"
        }
    ]
}

